<template>
  <div id="main-wrapper" class="main-wrapper">
    <MainNav />
    <router-view></router-view>
    <RGFooter :year="currentYear()" />
    <CookieModal />
  </div>
</template>

<script>
import MainNav from "@components/MainNav";
import RGFooter from "@components/RGFooter";
import CookieModal from "@components/cookies/ModalCookie";
export default {
  name: "MainLayout",
  components: {RGFooter, MainNav, CookieModal},
  methods: {
    currentYear(){
      return new Date().getFullYear();
    },
  }
}
</script>
